import { Box } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { BankRatingDetail } from "Components/Shared/BanksList/BankButton/Components/BankRatingDetail/BankRatingDetail";
import type { Bank } from "Infrastructure/Api/Api";
import { useParams } from "react-router-dom";
import { Resources, useResource } from "Translations/Resources";

const BankConnectionRankingDetailPage = () => {
  const { t } = useResource();
  const { bank } = useParams();

  const bankParam = bank as Bank;

  return (
    <AuthenticatedLayout
      title={t(Resources.BankRating.Title)}
      backNavigation={{ mode: "historyStack", fallbackUrl: null }}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <PrimaryPaper>
            <BankRatingDetail bank={bankParam} />
          </PrimaryPaper>
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default BankConnectionRankingDetailPage;
